import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HostnameContainerModel} from '../../../../../models/aggregates/hostname';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {ApiVisa} from "../shared";


@Injectable({
  providedIn: 'root'
})
export class HostnamePublicService extends BaseApiTemplateService<HostnameContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'hostnames-public';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'hostnames-public';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'hostnames-public';
    this.httpClient = http;
  }
  getHostnameImage(imageExtGuid: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/file/' + imageExtGuid;
    return this.httpClient.get(url, this.getHttpHeader(apiVisa));
  }
}
